import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "react";
import { LayoutGridComponents } from "./LayoutGridComponents";
import { LayoutGridSettingsContext } from "./LayoutGridSettingsContext";
/**
 * Renders layout grid (layout rows, columns)
 * @param props
 * @returns
 */
export function LayoutGrid(props) {
    var _a;
    const { gridMode } = useContext(LayoutGridSettingsContext);
    const GridComponent = (_a = LayoutGridComponents[gridMode]) !== null && _a !== void 0 ? _a : LayoutGridComponents.FlexboxGrid;
    return _jsx(GridComponent, Object.assign({}, props));
}
//# sourceMappingURL=LayoutGrid.js.map